<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="会员编号：" prop="member_code" v-if="model.id">
                <el-input v-model="model.member_code" disabled></el-input>
            </el-form-item>
            <el-form-item label="会员编号：" prop="member_code" v-else>
                <el-input v-model="model.member_code"></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <el-input v-model="model.cellphone"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="等级：" prop="level">
                <el-select clearable v-model="model.level" placeholder="请选择">
                    <el-option v-for="item in enuObj('promotion_level')" :key="'promotion_level'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <el-select clearable v-model="model.state" placeholder="请选择">
                    <el-option v-for="item in enuObj('userstate')" :key="'userstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'promotionMemberEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                member_code: '',
                name: '',
                cellphone: '',
                level: '',
                state: '',
                balance_settled: '',
                balance_ready: '',
                balance_wait: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/promotionmember/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['userstate','promotion_level'],
            rules: {
                member_code: [
                    {required: true, message: '会员编号不能为空', trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '姓名不能为空', trigger: 'blur'}
                ],
                cellphone: [
                    {required: true, message: '手机号不能为空', trigger: 'blur'}
                ],
                level: [
                    {required: true, message: '推广等级不能为空', trigger: 'blur'}
                ],
                state: [
                    {required: true, message: '状态不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/promotionmember/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.state = this.model.state+""
            this.model.level = this.model.level+""
        }
    }
};
</script>